const APIConstant = {
  /* ===== 예시 ===== */
  EXAMPLE: `/example`,

  /* ===== Admin ===== */
  GET_ADMIN: `/admin/:admin_id`,
  GETS_ADMIN: `/admin`,
  CREATE_ADMIN: `/admin`,
  UPDATE_ADMIN: `/admin/:admin_id`,
  DELETE_ADMIN: `/admin/:admin_id`,

  /* ===== Alim Talk Template ===== */
  GET_ALIM_TALK_TEMPLATE: `/alim_talk/template/:alim_talk_template_id`,
  GETS_ALIM_TALK_TEMPLATE: `/alim_talk/template`,
  CREATE_ALIM_TALK_TEMPLATE: `/alim_talk/template`,
  UPDATE_ALIM_TALK_TEMPLATE: `/alim_talk/template/:alim_talk_template_id`,
  DELETE_ALIM_TALK_TEMPLATE: `/alim_talk/template/:alim_talk_template_id`,

  /* ===== Auth ===== */
  AUTH_CHECK: `/auth/check`,
  ADMIN_LOGIN: `/auth/admin/login`,
  USER_LOGIN: `/auth/user/login`,
  DUPLICATE_CHECK: `/auth/duplicate/check`,
  SOCIAL_LOGIN: `/auth/social/callback`,
  VERIFY_PREV: `/auth/verify/prev`,
  VERIFY: `/auth/verify`,
  FIND_ACCOUNT: `/auth/users/verify`,

  /* ===== Banner ===== */
  GET_BANNER: `/banner/:banner_id`,
  GETS_BANNER: `/banner`,
  CREATE_BANNER: `/banner`,
  UPDATE_BANNER: `/banner/:banner_id`,
  DELETE_BANNER: `/banner/:banner_id`,
  BULK_UPSERT_BANNER: `/banner/bulk/upsert`,

  /* ===== Barcode ===== */
  CREATE_QR_URL: `/qrcode/url`,
  CREATE_QR_STRING: `/qrcode/string`,
  CREATE_QR_BUFFER: `/qrcode/buffer`,
  CREATE_BARCODE_URL: `/barcode/url`,
  CREATE_BARCODE_BUFFER: `/barcode/buffer`,

  /* ===== Benefit ===== */
  GET_BENEFIT: `/benefit/:benefit_id`,
  GETS_BENEFIT: `/benefit`,
  CREATE_BENEFIT: `/benefit`,
  UPDATE_BENEFIT: `/benefit/:benefit_id`,
  DELETE_BENEFIT: `/benefit/:benefit_id`,

  /* ===== Biz ===== */
  BIZ_SEND_SMS: `/biz/sms/send`,
  BIZ_SEND_LMS: `/biz/lms/send`,
  BIZ_SEND_MMS: `/biz/mms/send`,
  BIZ_SEND_KAKAO_AT: `/biz/kakao/send/at`,
  BIZ_SEND_KAKAO_AI: `/biz/kakao/send/ai`,
  BIZ_FILE_UPLOAD: `/biz/file/upload`,
  BIZ_TEMPLATE_ADD: `/biz/template/add`,
  BIZ_TEMPLATE_CODE_CHECK: `/biz/template/code_check`,
  BIZ_TEMPLATE_LIST: `/biz/template/list`,
  BIZ_TEMPLATE_DETAIL: `/biz/template/detail`,
  BIZ_TEMPLATE_UPDATE: `/biz/template/update`,
  BIZ_TEMPLATE_DELETE: `/biz/template/delete`,
  BIZ_TEMPLATE_CATEGORY_ALL: `/biz/template/category/all`,
  BIZ_TEMPLATE_CATEGORY: `/biz/template/category`,
  BIZ_TEMPLATE_REQUEST: `/biz/template/request`,
  BIZ_TEMPLATE_CANCEL_REQUEST: `/biz/template/cancel_request`,
  BIZ_TEMPLATE_STOP: `/biz/template/stop`,
  BIZ_TEMPLATE_REUSE: `/biz/template/reuse`,
  BIZ_TEMPLATE_CANCEL_APPROVAL: `/biz/template/cancel_approval`,
  BIZ_TEMPLATE_RELEASE: `/biz/template/release`,
  BIZ_TEMPLATE_CONVERT_ADD_CH: `/biz/template/convert_add_ch`,
  BIZ_TEMPLATE_REPLACE: `/biz/template/replace`,

  /* ===== Card ===== */
  GET_CARD: `/card/:card_id`,
  GETS_CARD: `/card`,
  CREATE_CARD: `/card`,
  UPDATE_CARD: `/card/:card_id`,
  DELETE_CARD: `/card/:card_id`,

  /* ===== Cart ===== */
  GET_CART: `/cart/:cart_id`,
  GETS_CART: `/cart`,
  CREATE_CART: `/cart`,
  UPDATE_CART: `/cart/:cart_id`,
  DELETE_CART: `/cart/:cart_id`,
  UPSERT_BULK_CART: `/cart/bulk/upsert`,
  BULK_DELETE_CART: `/cart/bulk/delete`,

  /* ===== Commission ===== */
  GET_COMMISSION: `/commission/:commission_id`,
  GETS_COMMISSION: `/commission`,
  CREATE_COMMISSION: `/commission`,
  UPDATE_COMMISSION: `/commission/:commission_id`,
  DELETE_COMMISSION: `/commission/:commission_id`,

  /* ===== Coupon ===== */
  GET_COUPON: `/coupon/:coupon_id`,
  GETS_COUPON: `/coupon`,
  CREATE_COUPON: `/coupon`,
  GETS_MAP_COUPON: `/coupon/policy/menu`,
  MAP_CREATE_COUPON: `/coupon/batch/process/menu`,
  MAP_CREATE_PRODUCT_COUPON: `/coupon/batch/process/product`,
  UPDATE_COUPON: `/coupon/:coupon_id`,
  DELETE_COUPON: `/coupon/:coupon_id`,
  GETS_MAP_PRODUCT_COUPON: `/coupon/policy/product`,

  /* ===== Coupon User ===== */
  GET_COUPON_USER: `/coupon_user/:coupon_user_id`,
  GETS_COUPON_USER: `/coupon_user`,
  CREATE_COUPON_USER: `/coupon_user`,
  UPDATE_COUPON_USER: `/coupon_user/:coupon_user_id`,
  DELETE_COUPON_USER: `/coupon_user/:coupon_user_id`,
  REGISTER_COUPON_USER: `/coupon_user/register`,
  BULK_CREATE_COUPON_USER: `/coupon_user/bulk/create`,
  BULK_UPDATE_COUPON_USER: `/coupon_user/bulk/update`,

  /* ===== Delivery Address ===== */
  GET_DELIVERY_ADDRESS: `/delivery_address/:delivery_address_id`,
  GETS_DELIVERY_ADDRESS: `/delivery_address`,
  CREATE_DELIVERY_ADDRESS: `/delivery_address`,
  UPDATE_DELIVERY_ADDRESS: `/delivery_address/:delivery_address_id`,
  DELETE_DELIVERY_ADDRESS: `/delivery_address/:delivery_address_id`,

  /* ==== Device ===== */
  GET_DEVICE: `/device/:device_id`,
  GETS_DEVICE: `/device`,
  CREATE_DEVICE: `/device`,
  UPDATE_DEVICE: `/device/:device_id`,
  DELETE_DEVICE: `/device/:device_id`,

  /* ===== Notice ===== */
  GET_EVENT: `/event/:event_id`,
  GETS_EVENT: `/event`,
  CREATE_EVENT: `/event`,
  UPDATE_EVENT: `/event/:event_id`,
  DELETE_EVENT: `/event/:event_id`,
  BULK_UPSERT_EVENT: `/event/bulk/upsert`,

  /* ===== Email History ===== */
  GET_EMAIL_HISTORY: `/email_history/:email_history_id`,
  GETS_EMAIL_HISTORY: `/email_history`,
  CREATE_EMAIL_HISTORY: `/email_history`,
  UPDATE_EMAIL_HISTORY: `/email_history/:email_history_id`,
  DELETE_EMAIL_HISTORY: `/email_history/:email_history_id`,

  /* ===== Email Template ===== */
  GET_EMAIL_TEMPLATE: `/email/template/:email_template_id`,
  GETS_EMAIL_TEMPLATE: `/email/template`,
  CREATE_EMAIL_TEMPLATE: `/email/template`,
  UPDATE_EMAIL_TEMPLATE: `/email/template/:email_template_id`,
  DELETE_EMAIL_TEMPLATE: `/email/template/:email_template_id`,
  GET_EMAIL_HISTORIES: `/email/history`,

  /* ===== File ===== */
  UPLOAD_FILE: `/file/upload`,
  UPLOAD_MULTI_FILE: `/file/upload/multi`,
  DOWNLOAD_FILE: `/file/download`,
  MULTI_UPLOAD_FILE: `/file/upload/multi`,

  /* ===== Forwarding Location ===== */
  GET_FORWARDING_LOCATION: `/forwarding_location/:forwarding_location_id`,
  GETS_FORWARDING_LOCATION: `/forwarding_location`,
  CREATE_FORWARDING_LOCATION: `/forwarding_location`,
  UPDATE_FORWARDING_LOCATION: `/forwarding_location/:forwarding_location_id`,
  DELETE_FORWARDING_LOCATION: `/forwarding_location/:forwarding_location_id`,

  /* ===== Frequency ===== */
  GET_FREQUENCY: `/frequency/:frequency_id`,
  GETS_FREQUENCY: `/frequency`,
  CREATE_FREQUENCY: `/frequency`,
  UPDATE_FREQUENCY: `/frequency/:frequency_id`,
  DELETE_FREQUENCY: `/frequency/:frequency_id`,

  /* ===== Frequency File ===== */
  GET_FREQUENCY_FILE: `/frequency_file/:frequency_file_id`,
  GETS_FREQUENCY_FILE: `/frequency_file`,
  CREATE_FREQUENCY_FILE: `/frequency_file`,
  UPDATE_FREQUENCY_FILE: `/frequency_file/:frequency_file_id`,
  DELETE_FREQUENCY_FILE: `/frequency_file/:frequency_file_id`,

  /* ===== Group Product ===== */
  GET_GROUP_PRODUCT: `/group_product/:group_product_id`,
  GETS_GROUP_PRODUCT: `/group_product`,
  GETS_MAP_GROUP_PRODUCT: `/group_product/policy/product`,
  CREATE_GROUP_PRODUCT: `/group_product`,
  UPDATE_GROUP_PRODUCT: `/group_product/:group_product_id`,
  DELETE_GROUP_PRODUCT: `/group_product/:group_product_id`,
  BULK_UPSERT_GROUP_PRODUCT: `/group_product/bulk/upsert`,
  MAP_CREATE_GROUP_PRODUCT: `/group_product/batch/process/product`,

  /* ===== Inquiry ===== */
  GET_INQUIRY: `/inquiry/:inquiry_id`,
  GETS_INQUIRY: `/inquiry`,
  CREATE_INQUIRY: `/inquiry`,
  UPDATE_INQUIRY: `/inquiry/:inquiry_id`,
  DELETE_INQUIRY: `/inquiry/:inquiry_id`,

  /* ===== Inquiry File ===== */
  GET_INQUIRY_FILE: `/inquiry_file/:inquiry_file_id`,
  GETS_INQUIRY_FILE: `/inquiry_file`,
  CREATE_INQUIRY_FILE: `/inquiry_file`,
  UPDATE_INQUIRY_FILE: `/inquiry_file`,
  DELETE_INQUIRY_FILE: `/inquiry_file`,
  BULK_CREATE_INQUIRY_FILE: `/file/inquiry_file/bulk/create`,

  /* ===== JM Pay ===== */
  GET_JM_PAY: `/jm_pay/:jm_pay_id`,
  GETS_JM_PAY: `/jm_pay`,
  CREATE_JM_PAY: `/jm_pay`,
  UPDATE_JM_PAY: `/jm_pay/:jm_pay_id`,
  DELETE_JM_PAY: `/jm_pay/:jm_pay_id`,
  AUTO_CHARGE_JM_PAY: `/jm_pay/charge/auto`,
  MANUAL_CHARGE_JM_PAY: `/jm_pay/charge/manual`,
  CANCEL_CHARGE_JM_PAY: `/jm_pay/charge/cancel`,
  REFUND_CHARGE_JM_PAY: `/jm_pay/charge/refund`,

  /* ===== MemberShip Grade ===== */
  GET_MEMBERSHIP_GRADE: `/membership_grade/:membership_grade_id`,
  GETS_MEMBERSHIP_GRADE: `/membership_grade`,
  CREATE_MEMBERSHIP_GRADE: `/membership_grade`,
  UPDATE_MEMBERSHIP_GRADE: `/membership_grade/:membership_grade_id`,
  DELETE_MEMBERSHIP_GRADE: `/membership_grade/:membership_grade_id`,

  /* ===== Map Menu Policy ===== */
  GET_MAP_MENU_POLICY: `/map_menu_policy/:map_menu_policy_id`,
  GETS_MAP_MENU_POLICY: `/map_menu_policy`,
  CREATE_MAP_MENU_POLICY: `/map_menu_policy`,
  UPDATE_MAP_MENU_POLICY: `/map_menu_policy/:map_menu_policy_id`,
  BULK_UPDATE_MAP_MENU_POLICY: `/map_menu_policy/bulk/update`,
  DELETE_MAP_MENU_POLICY: `/map_menu_policy/:map_menu_policy_id`,

  /* ===== Map Product Policy ===== */
  GET_MAP_PRODUCT_POLICY: `/map_product_policy/:map_product_policy_id`,
  GETS_MAP_PRODUCT_POLICY: `/map_product_policy`,
  CREATE_MAP_PRODUCT_POLICY: `/map_product_policy`,
  UPDATE_MAP_PRODUCT_POLICY: `/map_product_policy/:map_product_policy_id`,
  DELETE_MAP_PRODUCT_POLICY: `/map_product_policy/:map_product_policy_id`,
  BULK_UPDATE_MAP_PRODUCT_POLICY: `/map_product_policy/bulk/update`,

  /* ===== Menu ===== */
  GET_MENU: `/menu/:menu_id`,
  GETS_MENU: `/menu`,
  CREATE_MENU: `/menu`,
  UPDATE_MENU: `/menu/:menu_id`,
  DELETE_MENU: `/menu/:menu_id`,

  /* ===== Menu File ===== */
  GET_MENU_FILE: `/file/menu_file/:menu_file_id`,
  GETS_MENU_FILE: `/file/menu_file`,
  CREATE_MENU_FILE: `/file/menu_file`,
  UPDATE_MENU_FILE: `/file/menu_file/:menu_file_id`,
  DELETE_MENU_FILE: `/file/menu_file/:menu_file_id`,

  /* ===== Menu WishList ===== */
  GET_MENU_WISHLIST: `/menu_wishlist/:menu_wishlist_id`,
  GETS_MENU_WISHLIST: `/menu_wishlist`,
  CREATE_MENU_WISHLIST: `/menu_wishlist`,
  UPDATE_MENU_WISHLIST: `/menu_wishlist/:menu_wishlist_id`,
  DELETE_MENU_WISHLIST: `/menu_wishlist/:menu_wishlist_id`,

  /* ===== Message History ===== */
  GET_MESSAGE_HISTORY: `/message_history/:message_history_id`,
  GETS_MESSAGE_HISTORY: `/message_history`,
  CREATE_MESSAGE_HISTORY: `/message_history`,
  UPDATE_MESSAGE_HISTORY: `/message_history/:message_history`,
  DELETE_MESSAGE_HISTORY: `/message_history/:message_history`,

  /* ===== Notice ===== */
  GET_NOTICE: `/notice/:notice_id`,
  GETS_NOTICE: `/notice`,
  CREATE_NOTICE: `/notice`,
  UPDATE_NOTICE: `/notice/:notice_id`,
  DELETE_NOTICE: `/notice/:notice_id`,

  /* ===== Option ===== */
  GET_OPTION: `/option/:option_id`,
  GETS_OPTION: `/option`,
  CREATE_OPTION: `/option`,
  UPDATE_OPTION: `/option/:option_id`,
  DELETE_OPTION: `/option/:option_id`,

  /* ===== Order ===== */
  GET_ORDER: `/order/:order_id`,
  GETS_ORDER: `/order`,
  CREATE_ORDER: `/order`,
  UPDATE_ORDER: `/order/:order_id`,
  UPDATE_STATUS_ORDER: `/order/status/:order_id`,
  DELETE_ORDER: `/order`,
  GET_GUEST_ORDER: `/order/guest`,

  /* ===== Order Reservation ===== */
  GET_ORDER_RESERVATION: `/order_reservation/:order_reservation_id`,
  GETS_ORDER_RESERVATION: `/order_reservation`,
  CREATE_ORDER_RESERVATION: `/order_reservation`,
  UPDATE_ORDER_RESERVATION: `/order_reservation/:order_reservation_id`,
  DELETE_ORDER_RESERVATION: `/order_reservation/:order_reservation_id`,

  /* ===== Payment ===== */
  CANCEL_CARD: `/payment/kspay/card/cancel`,
  CANCEL_ACCOUNT: `/payment/kspay/account/cancel`,
  CANCEL_MOBILE: `/payment/kspay/mobile/cancel`,
  ISSUE_ONETIME_VACCOUNT: `/payment/kspay/vaccount/issue/onetime`,
  RECALL_VACCOUNT: `/payment/kspay/vaccount/recall`,
  ISSUE_CASHBILL: `/payment/kspay/cashbill/issue`,
  CANCEL_CASHBILL: `/payment/kspay/cashbill/cancel`,
  REGIST_BILLING: `/payment/kspay/billing/regist`,
  QUERY_BILLING: `/payment/kspay/billing/query`,
  DEREGIST_BILLING: `/payment/kspay/billing/deregist`,
  PAY_BILLING: `/payment/kspay/billing/pay`,

  /* ===== Parcel Service ===== */
  GET_PARCEL_SERVICE: `/parcel_service/:parcel_service_id`,
  GETS_PARCEL_SERVICE: `/parcel_service`,
  CREATE_PARCEL_SERVICE: `/parcel_service`,
  UPDATE_PARCEL_SERVICE: `/parcel_service/:parcel_service_id`,
  DELETE_PARCEL_SERVICE: `/parcel_service/:parcel_service_id`,
  BULK_CREATE_PARCEL_SERVICE: `/parcel_service/bulk/create`,
  BULK_UPDATE_PARCEL_SERVICE: `/parcel_service/bulk/update`,
  BULK_DELETE_PARCEL_SERVICE: `/parcel_service/bulk/delete`,
  UPDATE_PARCEL_SERVICE_STATUS: `/parcel_service/status/:parcel_service_id`,
  UPDATE_PARCEL_SERVICE_STATUS_BULK: `/parcel_service/bulk/status`,
  CONFIRM_PARCEL_SERVICE_STATUS: `/parcel_service/confirm/:parcel_service_id`,

  /* ===== Point History ===== */
  GET_POINT_HISTORY: `/point_history/:point_history_id`,
  GETS_POINT_HISTORY: `/point_history`,
  CREATE_POINT_HISTORY: `/point_history`,
  UPDATE_POINT_HISTORY: `/point_history/:point_history_id`,
  DELETE_POINT_HISTORY: `/point_history/:point_history_id`,
  UPSERT_POINT_HISTORY: `/point_history/bulk/reward`,
  USE_POINT_HISTORY: `/point_history/use`,

  /* ===== Point History Log ===== */
  GET_POINT_HISTORY_LOG: `/point_history_log/:point_history_log_id`,
  GETS_POINT_HISTORY_LOG: `/point_history_log`,
  CREATE_POINT_HISTORY_LOG: `/point_history_log`,
  UPDATE_POINT_HISTORY_LOG: `/point_history_log/:point_history_log_id`,
  DELETE_POINT_HISTORY_LOG: `/point_history_log/:point_history_log_id`,

  /* ===== Popup ===== */
  GET_POPUP: `/popup/:popup_id`,
  GETS_POPUP: `/popup`,
  CREATE_POPUP: `/popup`,
  UPDATE_POPUP: `/popup/:popup_id`,
  DELETE_POPUP: `/popup/:popup_id`,

  /* ===== Present ===== */
  GET_PRESENT: `/present/:present_id`,
  GETS_PRESENT: `/present`,
  CREATE_PRESENT: `/present`,
  UPDATE_PRESENT: `/present/:present_id`,
  DELETE_PRESENT: `/present/:present_id`,
  SEND_PRESENT: `/present/send`,
  GETS_PRESENT_GUEST: `/present/guest`,
  CANCEL_PRESENT: '/present/cancel/:present_id',

  /* ===== Present Card ===== */
  GET_PRESENT_CARD: `/present_card/:present_card_id`,
  GETS_PRESENT_CARD: `/present_card`,
  CREATE_PRESENT_CARD: `/present_card`,
  UPDATE_PRESENT_CARD: `/present_card/:present_card_id`,
  DELETE_PRESENT_CARD: `/present_card/:present_card_id`,
  UPSERT_PRESENT_CARD: `/present_card/bulk/upsert`,

  /* ===== Product ===== */
  GET_PRODUCT: `/product/:product_id`,
  GETS_PRODUCT: `/product`,
  CREATE_PRODUCT: `/product`,
  UPDATE_PRODUCT: `/product/:product_id`,
  DELETE_PRODUCT: `/product/:product_id`,
  GETS_PRODUCT_LIST: `/product/list`,
  UPSERT_PRODUCT: `/product/bulk/upsert`,

  /* ===== Product Category ===== */
  GET_PRODUCT_CATEGORY: `/product_category/:product_category_id`,
  GETS_PRODUCT_CATEGORY: `/product_category`,
  CREATE_PRODUCT_CATEGORY: `/product_category`,
  UPDATE_PRODUCT_CATEGORY: `/product_category/:product_category_id`,
  DELETE_PRODUCT_CATEGORY: `/product_category/:product_category_id`,
  UPSERT_PRODUCT_CATEGORY: `/product_category/bulk/upsert`,

  /* ===== Product File ===== */
  GET_PRODUCT_FILE: `/file/product_file/:product_file_id`,
  GETS_PRODUCT_FILE: `/file/product_file`,
  CREATE_PRODUCT_FILE: `/file/product_file`,
  UPDATE_PRODUCT_FILE: `/file/product_file/:product_file_id`,
  DELETE_PRODUCT_FILE: `/file/product_file/:product_file_id`,

  /* ===== Product Policy ===== */
  GET_PRODUCT_POLICY: `/product_policy/:product_policy_id`,
  GETS_PRODUCT_POLICY: `/product_policy`,
  CREATE_PRODUCT_POLICY: `/product_policy`,
  UPDATE_PRODUCT_POLICY: `/product_policy/:product_policy_id`,
  DELETE_PRODUCT_POLICY: `/product_policy/:product_policy_id`,

  /* ===== Product Tag ===== */
  GET_PRODUCT_TAG: `/product_tag/:product_tag_id`,
  GETS_PRODUCT_TAG: `/product_tag`,
  CREATE_PRODUCT_TAG: `/product_tag`,
  UPDATE_PRODUCT_TAG: `/product_tag/:product_tag_id`,
  DELETE_PRODUCT_TAG: `/product_tag/:product_tag_id`,
  BULK_CREATE_PRODUCT_TAG: `/product_tag/bulk/create`,
  BULK_DELETE_PRODUCT_TAG: `/product_tag/bulk/delete`,

  /* ===== Promotion ===== */
  GET_PROMOTION: `/promotion/:promotion_id`,
  GET_PROMOTIONS_MAPPING: `/promotion/policy/product`,
  GETS_PROMOTION: `/promotion`,
  CREATE_PROMOTION: `/promotion`,
  UPDATE_PROMOTION: `/promotion/:promotion_id`,
  DELETE_PROMOTION: `/promotion/:promotion_id`,
  BULK_UPSERT_PROMOTION: `/promotion/bulk/upsert`,
  MAP_CREATE_PROMOTION: `/promotion/batch/process/product`,

  /* ===== Promotion Shop ===== */
  GET_PROMOTION_SHOP: `/promotion_shop/:promotion_shop_id`,
  GETS_PROMOTION_SHOP: `/promotion_shop`,
  CREATE_PROMOTION_SHOP: `/promotion_shop`,
  UPDATE_PROMOTION_SHOP: `/promotion_shop/:promotion_shop_id`,
  DELETE_PROMOTION_SHOP: `/promotion_shop/:promotion_shop_id`,

  /* ===== Provision ===== */
  GET_PROVISION: `/provision/:provision_id`,
  GETS_PROVISION: `/provision`,
  CREATE_PROVISION: `/provision`,
  UPDATE_PROVISION: `/provision/:provision_id`,
  DELETE_PROVISION: `/provision/:provision_id`,

  /* ===== Push History ===== */
  GET_PUSH_HISTORY: `/push_history/:push_history_id`,
  GETS_PUSH_HISTORY: `/push_history`,
  CREATE_PUSH_HISTORY: `/push_history`,
  UPDATE_PUSH_HISTORY: `/push_history/:push_history_id`,
  DELETE_PUSH_HISTORY: `/push_history/:push_history_id`,

  /* ===== Push Template ===== */
  GET_PUSH_TEMPLATE: `/push/template/:push_template_id`,
  GETS_PUSH_TEMPLATE: `/push/template`,
  CREATE_PUSH_TEMPLATE: `/push/template`,
  UPDATE_PUSH_TEMPLATE: `/push/template/:push_template_id`,
  DELETE_PUSH_TEMPLATE: `/push/template/:push_template_id`,
  GET_PUSH_HISTORIES: `/push/history`,

  /* ===== GRADE ===== */
  GET_GRADE: `/grade/:grade_id`,
  GETS_GRADE: `/grade`,
  CREATE_GRADE: `/grade`,
  UPDATE_GRADE: `/grade/:grade_id`,
  DELETE_GRADE: `/grade/:grade_id`,

  /* ===== Rental ===== */
  GET_RENTAL: `/rental/:rental_id`,
  GETS_RENTAL: `/rental`,
  CREATE_RENTAL: `/rental`,
  UPDATE_RENTAL: `/rental/:rental_id`,
  DELETE_RENTAL: `/rental/:rental_id`,
  BULK_CREATE_RENTAL: `/rental/bulk/create`,
  BULK_UPDATE_RENTAL: `/rental/bulk/update`,
  BULK_DELETE_RENTAL: `/rental/bulk/delete`,
  UPDATE_STATUS_RENTAL: `/rental/status/:rental_id`,
  UPDATE_CONFIRM_RENTAL: `/rental/confirm/:rental_id`,

  /* ===== Rental Extension ===== */
  GET_RENTAL_EXTENSION: `/rental_extension/:rental_extension_id`,
  GETS_RENTAL_EXTENSION: `/rental_extension`,
  CREATE_RENTAL_EXTENSION: `/rental_extension`,
  UPDATE_RENTAL_EXTENSION: `/rental_extension/:rental_extension_id`,
  DELETE_RENTAL_EXTENSION: `/rental_extension/:rental_extension_id`,

  /* ===== Review ===== */
  GET_REVIEW: `/review/:review_id`,
  GETS_REVIEW: `/review`,
  CREATE_REVIEW: `/review`,
  UPDATE_REVIEW: `/review/:review_id`,
  DELETE_REVIEW: `/review/:review_id`,
  UPSERT_REVIEW: `/review/bulk/upsert`,
  BULK_DELETE_REVIEW: `/review/bulk/delete`,

  /* ===== Review File ===== */
  GET_REVIEW_FILE: `/file/review_file/:review_file_id`,
  GETS_REVIEW_FILE: `/file/review_file`,
  CREATE_REVIEW_FILE: `/file/review_file`,
  UPDATE_REVIEW_FILE: `/file/review_file/:review_file_id`,
  DELETE_REVIEW_FILE: `/file/review_file/:review_file_id`,
  BULK_CREATE_REVIEW_FILE: `/file/review_file/bulk/create`,

  /* ===== Refund ===== */
  GET_REFUND: `/refund/:refund_id`,
  GETS_REFUND: `/refund`,
  CREATE_REFUND: `/refund`,
  UPDATE_REFUND: `/refund/:refund_id`,
  ORDER_REFUND: `/refund/order`,
  DELETE_REFUND: `/refund/:refund_id`,
  DELIVERY_REFUND: `/refund/delivery`,
  DELIVERY_REFUND_MANUAL: `/refund/delivery/manual`,
  SUBSCRIPTION_REFUND: `/refund/subscription`,
  SUBSCRIPTION_REFUND_MANUAL: `/refund/subscription/manual`,
  RENTAL_REFUND: `/refund/rental`,
  RENTAL_REFUND_MANUAL: `/refund/rental/manual`,

  /* ===== Search Word ===== */
  GET_SEARCH_WORD: `/search_word/:search_word_id`,
  GETS_SEARCH_WORD: `/search_word`,
  CREATE_SEARCH_WORD: `/search_word`,
  UPDATE_SEARCH_WORD: `/search_word/:search_word_id`,
  DELETE_SEARCH_WORD: `/search_word/:search_word_id`,
  BULK_UPSERT_SEARCH_WORD: `/search_word/bulk/upsert`,
  /* ===== Send ===== */
  SEND_EMAIL: `/email/send`,
  SEND_SMS: `/sms/send`,
  SEND_PUSH_MESSAGE: `/push/send`,

  /* ===== Setting ===== */
  GET_SETTING: `/setting/:setting_id`,
  GETS_SETTING: `/setting`,
  CREATE_SETTING: `/setting`,
  UPDATE_SETTING: `/setting/:setting_id`,
  DELETE_SETTING: `/setting/:setting_id`,

  /* ===== Settlement Amount (정산) ===== */
  GET_SETTLEMENT_AMOUNT: `/settlement_amount/:settlement_amount_id`,
  GET_SETTLEMENT_AMOUNT_LIST: `/settlement_amount`,
  GETS_SETTLEMENT_AMOUNT: `/settlement_amount`,
  CREATE_SETTLEMENT_AMOUNT: `/settlement_amount`,
  UPDATE_SETTLEMENT_AMOUNT: `/settlement_amount/:settlement_amount_id`,
  BULK_UPDATE_SETTLEMENT_AMOUNT: `/settlement_amount/bulk/upsert`,
  DELETE_SETTLEMENT_AMOUNT: `/settlement_amount/:settlement_amount_id`,

  /* ===== Shop ===== */
  GET_SHOP: `/shop_information/:shop_information_id`,
  GETS_SHOP: `/shop_information`,
  CREATE_SHOP: `/shop_information`,
  UPDATE_SHOP: `/shop_information/:shop_information_id`,
  DELETE_SHOP: `/shop_information/:shop_information_id`,

  /* ===== Shop File ===== */
  GET_SHOP_FILE: `/file/shop_information_file/:shop_information_file_id`,
  GETS_SHOP_FILE: `/file/shop_information_file`,
  CREATE_SHOP_FILE: `/file/shop_information_file`,
  UPDATE_SHOP_FILE: `/file/shop_information_file/:shop_information_file_id`,
  DELETE_SHOP_FILE: `/file/shop_information_file/:shop_information_file_id`,

  /* ===== Shop Menu ===== */
  GET_SHOP_MENU: `/shop_menu/:shop_menu_id`,
  GETS_SHOP_MENU: `/shop_menu`,
  CREATE_SHOP_MENU: `/shop_menu`,
  UPDATE_SHOP_MENU: `/shop_menu/:shop_menu_id`,
  DELETE_SHOP_MENU: `/shop_menu/:shop_menu_id`,

  /* ===== Shop Order ===== */
  GET_SHOP_ORDER: `/shop_order/:shop_order_id`,
  GETS_SHOP_ORDER: `/shop_order`,
  CREATE_SHOP_ORDER: `/shop_order`,
  UPDATE_SHOP_ORDER: `/shop_order/:shop_order_id`,
  DELETE_SHOP_ORDER: `/shop_order/:shop_order_id`,

  /* ===== SMS Template ===== */
  GET_SMS_TEMPLATE: `/sms/template/:sms_template_id`,
  GETS_SMS_TEMPLATE: `/sms/template`,
  CREATE_SMS_TEMPLATE: `/sms/template`,
  UPDATE_SMS_TEMPLATE: `/sms/template/:sms_template_id`,
  DELETE_SMS_TEMPLATE: `/sms/template/:sms_template_id`,

  /* ===== Staff ===== */
  GET_STAFF: `/staff/:staff_id`,
  GETS_STAFF: `/staff`,
  CREATE_STAFF: `/staff`,
  UPDATE_STAFF: `/staff/:staff_id`,
  DELETE_STAFF: `/staff/:staff_id`,

  /* ===== Stamp ===== */
  GET_STAMP: `/stamp/:stamp_id`,
  GETS_STAMP: `/stamp`,
  CREATE_STAMP: `/stamp`,
  UPDATE_STAMP: `/stamp/:stamp_id`,
  DELETE_STAMP: `/stamp/:stamp_id`,

  /* ===== Stamp History ===== */
  GET_STAMP_HISTORY: `/stamp_history/:stamp_history_id`,
  GETS_STAMP_HISTORY: `/stamp_history`,
  CREATE_STAMP_HISTORY: `/stamp_history`,
  UPDATE_STAMP_HISTORY: `/stamp_history/:stamp_history_id`,
  DELETE_STAMP_HISTORY: `/stamp_history/:stamp_history_id`,
  REWARD_STAMP_HISTORY: `/stamp_history/reward`,
  BULK_UPDATE_STAMP_HISTORY: `/stamp_history/bulk/update`,

  /* ==== Stock ===== */
  GET_STOCK: `/stock/:stock_id`,
  GETS_STOCK: `/stock`,
  CREATE_STOCK: `/stock`,
  UPDATE_STOCK: `/stock/:stock_id`,
  DELETE_STOCK: `/stock/:stock_id`,

  /* ===== Tag ===== */
  GET_TAG: `/tag/:tag_id`,
  GETS_TAG: `/tag`,
  CREATE_TAG: `/tag`,
  UPDATE_TAG: `/tag/:tag_id`,
  DELETE_TAG: `/tag/:tag_id`,

  /* ===== Tap Category ===== */
  GET_TAP_CATEGORY: `/tap_category/:tap_category_id`,
  GETS_TAP_CATEGORY: `/tap_category`,
  CREATE_TAP_CATEGORY: `/tap_category`,
  UPDATE_TAP_CATEGORY: `/tap_category/:tap_category_id`,
  DELETE_TAP_CATEGORY: `/tap_category/:tap_category_id`,

  /* ===== User ===== */
  GET_USER: `/user/:user_id`,
  GETS_USER: `/user`,
  CREATE_USER: `/user`,
  UPDATE_USER: `/user/:user_id`,
  DELETE_USER: `/user/:user_id`,
  UPDATE_USER_GUEST: `/user/guest/update`,
  BULK_UPSERT_USER: `/user/bulk/upsert`,
  BULK_UPDATE_USER_GRADE: `/user/grade/bulk/update`,

  /* ===== Wish List ===== */
  GET_WISHLIST: `/wishlist/wishlist_id`,
  GETS_WISHLIST: `/wishlist`,
  CREATE_WISHLIST: `/wishlist`,
  UPDATE_WISHLIST: `/wishlist/:wishlist_id`,
  DELETE_WISHLIST: `/wishlist/:wishlist_id`,

  /* ===== Withdraw ===== */
  GET_WITHDRAW: `/withdraw/:withdraw_id`,
  GETS_WITHDRAW: `/withdraw`,
  CREATE_WITHDRAW: `/withdraw`,
  UPDATE_WITHDRAW: `/withdraw/:withdraw_id`,
  BULK_UPDATE_WITHDRAW: `/withdraw/bulk/upsert`,
  DELETE_WITHDRAW: `/withdraw/:withdraw_id`,

  /* ===== Push Message ===== */
  SEND_PUSH: `/push/send`,
  GET_PUSH_HISTORY2: `/push/history`,
  GET_PUSH_TEMPLATES: `/push/template`,
  GET_USERS_WITH_DEVICE: `/user`,

  /* ===== [정산]Calculate ===== */

  /* ===== [통계] Statistics ===== */
  GET_STATISTICS: `/statistics/:type`,
  GET_STATISTICS_SUMMARY: `/statistics/summary/:type`,
  GET_STATISTICS_FOREIGN_CHECK: `/statistics/check/foreign-key`,
};

export default APIConstant;
